import { onDomReady } from '../utils/dom';
import { DropdownMenu } from '../utils/dropdown-menu';

export const breakPoint = 992;

/**
 * @typedef MenuOptions
 * @property {number} breakPoint
 * @property {string} selector
 * @property {string} navButton
 * @property {{ element: string, close: string }} [overlay]
 */

const MainMenu = {
    breakPoint,
    selector: '#header .main-nav',
    navButton: '#header .nav-button',
    // overlay: {
    //     element: '#nav-overlay',
    //     close: '#nav-close',
    // },
};

const FixedHeaderMainMenu = {
    breakPoint,
    selector: '#fixed-header .main-nav',
    navButton: '#fixed-header .nav-button',
};

onDomReady(() => {
    new DropdownMenu(MainMenu);

    if (document.getElementById('fixed-header')) {
        new DropdownMenu(FixedHeaderMainMenu);
    }
});
